export const GENERAL = 'general'
export const UNIT = 'unit'
export const UNIT_PRICE_QUOTATION_FIRST_STEP = 'unit-price-quotation-first-step'
export const UNIT_PRICE_QUOTATION_SECOND_STEP =
  'unit-price-quotation-second-step'
